<template>
  <div class="login-container">
    <h2>验证码登录</h2>
    <el-form ref="form" :model="formData" label-width="auto" @submit.prevent="submitLogin">
      <!-- 手机号输入 -->
      <el-form-item label="手机号码" prop="phoneNumber">
        <el-input v-model="formData.phoneNumber" placeholder="请输入手机号码" />
      </el-form-item>

      <!-- 获取验证码按钮 -->
      <el-form-item label="验证码">
        <el-button
            type="primary"
            @click="sendVerificationCode"
            :disabled="isSending || !formData.phoneNumber"
            style="width: 100%"
        >
          {{ isSending ? `${countdown} 秒后重发` : '获取验证码' }}
        </el-button>
      </el-form-item>

      <!-- 验证码输入框 -->
      <el-form-item label="输入验证码" prop="verificationCode" v-if="showVerificationInput">
        <el-input v-model="formData.verificationCode" placeholder="请输入验证码" />
      </el-form-item>

      <!-- 登录按钮 -->
      <el-form-item v-if="showVerificationInput">
        <el-button type="success" @click="submitLogin" style="width: 100%">登录</el-button>
      </el-form-item>

      <!-- 倒计时提示 -->
      <div v-if="countdown > 0 && isSending" class="countdown">
        验证码已发送，请查收短信。重新发送({{ countdown }}s)
      </div>
    </el-form>

    <!-- 错误提示 -->
    <el-alert v-if="error" :title="error" type="error" show-icon :closable="false" />
  </div>
</template>

<script>
import api from '@/api/competitionApplication';

export default {
  data() {
    return {
      formData: {
        phoneNumber: '',
        verificationCode: ''
      },
      showVerificationInput: false,
      isSending: false,
      countdown: 0,
      error: '',
      timer: null
    };
  },
  methods: {
    // 发送验证码
    sendVerificationCode() {
      const phone = this.formData.phoneNumber;
      if (!phone) {
        this.$message.error('请输入手机号');
        return;
      }

      if (!/^1[3-9]\d{9}$/.test(phone)) {
        this.$message.error('手机号格式不正确');
        return;
      }

      // 模拟请求
      console.log('发送验证码至:', phone);
      api.registerCode(phone)
          .then(res => {
            if (res.code === 200) {
              this.showVerificationInput = true;
              this.isSending = true;
              this.formData.verificationCode=res.data;
              this.startCountdown(60);
            } else {
              this.$message.error('验证码发送失败,请检查手机号码');
            }
          })
          .catch(err => {
            this.$message.error('网络异常，请稍后再试');
            console.error(err);
          });
    },

    // 开始倒计时
    startCountdown(seconds) {
      if (this.timer) clearInterval(this.timer);
      this.countdown = seconds;

      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.isSending = false;
        }
      }, 1000);
    },

    // 提交登录
    submitLogin() {
      const { phoneNumber, verificationCode } = this.formData;

      if (!phoneNumber || !/^1[3-9]\d{9}$/.test(phoneNumber)) {
        this.$message.error('请输入有效的手机号');
        return;
      }

      if (!verificationCode) {
        this.$message.error('请输入验证码');
        return;
      }

      // 模拟登录请求
      console.log('提交登录:', { phoneNumber, verificationCode });

      api.codeLogin({
        phone: phoneNumber,
        code: verificationCode
      }).then(res => {
        if (res.code === 200) {
          localStorage.setItem('token', res.data.token);
          this.$router.push('/compeForm');
        } else {
          this.$message.error(res.message || '登录失败');
        }
      }).catch(err => {
        this.$message.error('登录失败，请检查网络或稍后再试');
        console.error(err);
      });
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  }
};
</script>

<style scoped>
.login-container {
  max-width: 300px;
  margin: 50px auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
}

.countdown {
  font-size: 14px;
  color: #555;
}
</style>
